
const GEAR_TOOLTIPS = {
  weapons: <>Weapons that can be taken inside &quot;Gear&quot; tab during briefing</>,
  magazines: <>Ammo that can be taken inside &quot;Gear&quot; tab during briefing</>,
  extraField: <>Use this input field to access autocomplete with all weapon and magazine classes.</>
};

export default GEAR_TOOLTIPS;